import React from 'react';
import '../styles/tavern-components.css';

export interface TavernLoadingProps {
  message?: string;
  className?: string;
}

/**
 * Loading spinner with tavern styling
 * 
 * @example
 * <TavernLoading message="Loading quests..." />
 */
export function TavernLoading({
  message = 'Loading...',
  className = '',
}: TavernLoadingProps) {
  return (
    <div className={`tavern-loading ${className}`.trim()}>
      <div className="tavern-spinner" />
      {message && <div>{message}</div>}
    </div>
  );
}

export interface TavernEmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/**
 * Empty state component for lists
 * 
 * @example
 * <TavernEmptyState 
 *   icon="🗺️"
 *   title="No Quests Available"
 *   description="Check back later for new adventures!"
 * />
 * 
 * @example
 * <TavernEmptyState 
 *   icon="🛡️"
 *   title="No Groups Found"
 *   description="Create your first party to begin your journey"
 *   action={<TavernButton onClick={createGroup}>Create Group</TavernButton>}
 * />
 */
export function TavernEmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: TavernEmptyStateProps) {
  return (
    <div className={`tavern-empty-state ${className}`.trim()}>
      {icon && <div className="tavern-empty-state-icon">{icon}</div>}
      <div className="tavern-empty-state-title">{title}</div>
      {description && (
        <div className="tavern-empty-state-description">{description}</div>
      )}
      {action && <div style={{ marginTop: 'var(--space-5)' }}>{action}</div>}
    </div>
  );
}
